import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter" }
const _hoisted_2 = { class: "date" }
const _hoisted_3 = { class: "date" }
const _hoisted_4 = {
  key: 0,
  class: "mt-8"
}

import ListFilter from '@/components/common/ListFilter.vue';
import UserForm from '@/components/users/UserForm.vue';
import UserRequestForm from '@/components/users/UserRequestForm.vue';
import { User, getUserType, UserLevel } from '@/models/user.model';
import { FilterData } from '@/services/users.service';
import { Mutations, ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { format } from 'date-fns';
import { computed, markRaw, onBeforeUnmount, onMounted, Ref, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UsersList',
  setup(__props) {

const store = useStore<ShiftCMSState & { us: UsersState }>();

const total = computed<number>(() => store.state.us.userTotal);
const users = computed<User[]>(() => store.state.us.users);
const token = computed(() => store.state.token);

const filterData = ref<FilterData>({
  search: '',
  level: null,
  page: 1,
  count: 25,
  sort: 'id',
  direction: 'asc',
});

const addUser = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(UserForm) });
};

const editUser = (_: Event, { item }: { item: User }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(UserForm),
    data: item,
  });
};

const handleUserRequest = (_: Event, { item }: { item: User }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(UserRequestForm),
    data: item,
  });
};

const update = () => {
  store.dispatch(UsersActions.GetUserList, filterData.value);
};

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const tableType = ref<string>('one');

const headers = computed(() =>
  tableType.value === 'one'
    ? [
        { title: 'ID', key: 'id', width: '5%' },
        { title: 'Type', key: 'type', sortable: false, width: '5%' },
        { title: 'Name', key: 'name', width: '15%' },
        { title: 'Email', key: 'email', width: '19%' },
        { title: 'Quizzes', sortable: false, key: 'stories', width: '2%' },
        { title: 'List', sortable: false, key: 'actions', width: '2%' },
        { title: 'Registration', key: 'creationDate' },
        { title: 'Active', key: 'activeDate' },
        { title: 'Status', key: 'state' },
      ]
    : [
        { title: 'ID', key: 'id', sortable: false, width: '5%' },
        { title: 'Name', key: 'name', width: '15%' },
        { title: 'Email', key: 'email', width: '19%' },
        { title: 'Postalcode', key: 'postal_code', width: '10%' },
        { title: 'City', key: 'city', width: '10%' },
        { title: 'Registration', key: 'creationDate' },
      ],
);

const requestHeaders = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Email', key: 'email', width: '20%' },
  { title: 'Type', key: 'type', width: '75%' },
];

function updateFilter(filters: { filter: UserLevel; filterTitle: string }) {
  filterData.value = {
    ...filterData.value,
    level: filters.filter,
    search: filters.filterTitle,
  };
  resetPage();
  update();
}

function updateItemsPerPage(count: number) {
  filterData.value = { ...filterData.value, count };
  update();
}
function updatePage(page: number) {
  filterData.value = { ...filterData.value, page };
  update();
}

function resetPage() {
  filterData.value = { ...filterData.value, page: 1 };
}
function updateSortBy(sorting: { key: string; order: 'asc' | 'desc' }[]) {
  if (sorting.length) {
    const { key, order } = sorting[0];

    filterData.value = { ...filterData.value, sort: key, direction: order };
    resetPage();
    update();
  }
}

const ids = ref<string>('');

const parseUsers = () => {
  ids.value = ids.value.replace(/[\n|\s]/g, ',');
};
const downloadUsers = (isActive: Ref) => {
  window.open(`/api/user-csv/${ids.value}?token=${token.value}`, 'new');

  isActive.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[9] || (_cache[9] = _createElementVNode("h2", null, "Users", -1)),
      _createVNode(ListFilter, {
        options: [
        { label: 'Admin', value: _unref(UserLevel).Admin },
        { label: 'Editor', value: _unref(UserLevel).ContentEditor },
        { label: 'User', value: _unref(UserLevel).RegisteredUser },
        { label: 'Device', value: _unref(UserLevel).Device },
      ],
        onFilter: updateFilter
      }, {
        default: _withCtx(() => [
          _createElementVNode("li", _hoisted_1, [
            _createVNode(_component_v_btn, {
              flat: "",
              density: "compact",
              color: tableType.value === 'one' ? 'secondary' : '',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (tableType.value = tableType.value === 'one' ? 'two' : 'one'))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(tableType.value === 'one' ? 'User' : 'Email') + " list", 1)
              ]),
              _: 1
            }, 8, ["color"])
          ])
        ]),
        _: 1
      }, 8, ["options"]),
      _createVNode(_component_v_data_table_server, {
        density: "compact",
        "onClick:row": editUser,
        headers: headers.value,
        items: users.value,
        itemsLength: total.value,
        itemsPerPage: filterData.value.count,
        page: filterData.value.page,
        "onUpdate:itemsPerPage": updateItemsPerPage,
        "onUpdate:page": updatePage,
        "onUpdate:sortBy": updateSortBy,
        hover: ""
      }, {
        "item.name": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1)
        ]),
        "item.type": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_unref(getUserType)(item)), 1)
        ]),
        "item.stories": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.stories.filter((s) => s.watchedDate).length), 1)
        ]),
        "item.actions": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.actions.length + item.initiatives.length), 1)
        ]),
        "item.creationDate": _withCtx(({ value }) => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(format)(value, 'd/M/yyyy - HH:mm')), 1)
        ]),
        "item.activeDate": _withCtx(({ value }) => [
          _createElementVNode("span", _hoisted_3, _toDisplayString(value ? _unref(format)(value, 'd/M/yyyy - HH:mm') : '-'), 1)
        ]),
        "item.postal_code": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.address?.postal_code), 1)
        ]),
        "item.city": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.address?.city), 1)
        ]),
        "item.state": _withCtx(({ item }) => [
          (item.level === _unref(UserLevel).Admin && item.twoFactorEnabled)
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 0,
                variant: "flat",
                density: "compact",
                color: "info"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("2FA")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (item.level === _unref(UserLevel).Admin && !item.twoFactorEnabled)
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 1,
                variant: "flat",
                density: "compact",
                color: "warning"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("No 2FA")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["headers", "items", "itemsLength", "itemsPerPage", "page"]),
      _createVNode(_component_v_btn, {
        onClick: addUser,
        color: "success"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("Add User")
        ])),
        _: 1
      }),
      _createVNode(_component_v_dialog, { width: "auto" }, {
        activator: _withCtx(({ props: activatorProps }) => [
          _createVNode(_component_v_btn, _mergeProps({ class: "ml-4" }, activatorProps, { color: "success" }), {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Download CSV")
            ])),
            _: 2
          }, 1040)
        ]),
        default: _withCtx(({ isActive }) => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Download CSV", -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("p", null, "Provide IDS of users you wish the download.", -1)),
                  _createVNode(_component_v_text_field, {
                    modelValue: ids.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ids).value = $event)),
                    label: "1, 2, 4, 1029... ",
                    hint: "(spaces or linebreaks are also allowed)",
                    onKeyup: parseUsers
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    color: "success",
                    type: "button",
                    block: "",
                    onClick: () => downloadUsers(isActive)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Download " + _toDisplayString(ids.value.length ? `${ids.value}`.split(',').length + ' users' : ''), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }),
      (
        users.value.filter(
          (u) => u.requestedAccountDeletion || u.requestedDataRemoval,
        ).length
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_v_alert, { type: "warning" }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Users that want their data or account deleted.")
              ])),
              _: 1
            }),
            _createVNode(_component_v_data_table, {
              class: "mt-8",
              "onClick:row": handleUserRequest,
              density: "compact",
              headers: requestHeaders,
              items: 
          users.value.filter(
            (u) => u.requestedAccountDeletion || u.requestedDataRemoval,
          )
        ,
              itemsPerPage: "25",
              hover: ""
            }, {
              "item.type": _withCtx(({ item }) => [
                _createTextVNode(_toDisplayString(item.requestedAccountDeletion ? 'Delete account' : 'Delete data'), 1)
              ]),
              _: 1
            }, 8, ["items"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})